<template>
  <div>
    <b-table
      hover
      small
      responsive
      v-if="items.length > 0"
      :items="items"
      :fields="fields"
      @row-clicked="onRowClicked"
      sort-by="_sortField"
    >
      <template v-slot:cell(Контекст)="data">
        {{ data.value }}
      </template>
      <template v-slot:cell(Важность)="data">
        <strong v-if="data.value == 'error'">{{ data.value }}</strong>
        <em v-else>{{ data.value }}</em>
      </template>
      <template v-slot:cell()="data">
        <pre>{{ data.value }}</pre>
      </template>
    </b-table>
    <div v-else>
      <em class="fas fa-check text-primary"></em> Ошибок не обнаружено
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ErrorSeverity } from '@/api/training/error'

const rowVariants = {}
rowVariants[ErrorSeverity.INFO] = 'info'
rowVariants[ErrorSeverity.WARN] = 'warning'
rowVariants[ErrorSeverity.ERROR] = 'danger'

const rowOrder = [ErrorSeverity.ERROR, ErrorSeverity.WARN, ErrorSeverity.INFO]

const mapError = (error) => ({
  Место: error.line !== undefined ? `${error.line}:${error.column}` : error.loc,
  Важность: error.severity,
  Сообщение: error.message,
  _rowVariant: rowVariants[error.severity],
  _sortField: rowOrder.indexOf(error.severity)
})

/**
 * Список ошибок
 * @vue-prop {Array.<ValidationError>} errors Список ошибок
 * @vue-prop {Object.<string, ValidationError>} scopedErrors
 * Список ошибок с контекстом (например, по файлам)
 * @vue-computed {Array} items преобразованный для b-table список ошибок
 */
export default {
  name: 'ErrorList',
  props: {
    errors: {
      type: Array
    },
    scopedErrors: {
      type: Object
    }
  },
  methods: {
    onRowClicked(item) {
      this.$emit('errorClicked', item)
    },
    loadScoped(scoped) {
      const result = []
      Object.entries(scoped).forEach(([scope, errors]) => {
        result.push(
          ...errors.map((error) => ({
            Контекст: scope,
            ...mapError(error)
          })),
        )
      })
      return result
    }
  },
  computed: {
    ...mapGetters({
      trainingErrors: 'training/getErrors'
    }),
    items() {
      if (this.errors) {
        return this.errors.map((error) => mapError(error))
      }
      if (this.scopedErrors) {
        return this.loadScoped(this.scopedErrors)
      }
      if (this.errors === undefined && this.scopedErrors === undefined) {
        return this.loadScoped(this.trainingErrors)
      }
      return []
    },
    fields() {
      if (this.errors) {
        return [
          'Место',
          'Важность',
          {
            key: 'Сообщение',
            label: 'Сообщение'
          }
        ]
      }
      return [
        'Контекст',
        'Место',
        'Важность',
        {
          key: 'Сообщение',
          label: 'Сообщение'
        }
      ]
    }
  }
}
</script>

<style scoped></style>
